{
  "assetContainerEvent": {
    "types": {
      "arrived": "มาถึงแล้ว",
      "arrivedWaiting": "มาถึงแล้ว/รอ",
      "loading": "กำลังขนสินค้าขึ้น",
      "loadingComplete": "ขนสินค้าขึ้นเสร็จสิ้น",
      "unloading": "กำลังขนสินค้าลง",
      "unloadingComplete": "ขนสินค้าลงเสร็จสิ้น",
      "readyForPickup": "พร้อมให้รับ",
      "departed": "ออกไปแล้ว",
      "inoperable": "ใช้งานไม่ได้",
      "missing": "สูญหาย",
      "inTransit": "กำลังเคลื่อนย้าย"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "มาถึงแล้ว",
    "Docked": "เข้าเทียบท่าแล้ว",
    "Parked": "จอดแล้ว",
    "Unassigned": "ยังไม่ได้มอบหมาย",
    "Dropped": "ปลดแล้ว",
    "Hooked": "ต่อพ่วงแล้ว",
    "Appointment Linked": "เชื่อมโยงการนัดหมายแล้ว",
    "Appointment Unlinked": "ยกเลิกการเชื่อมโยงการนัดหมายแล้ว",
    "Status Updated": "อัปเดตสถานะ"
  },
  "assetContainerTypes": {
    "trailer": "รถพ่วง",
    "container": "ตู้คอนเทนเนอร์",
    "oversized": "ขนาดใหญ่พิเศษ",
    "chassis": "แชสซี",
    "reefer": "ตู้ควบคุมอุณหภูมิ",
    "other": "อื่น ๆ"
  },
  "assetVisitTypes": {
    "live": "รอขนถ่าย (Live)",
    "drop": "ปลดทิ้งไว้ (Drop)",
    "pickup": "ต่อพ่วง (Hook)",
    "dropHook": "ปลดและต่อพ่วง (Drop & Hook)"
  },
  "assetVisitDirections": {
    "inbound": "ขาเข้า",
    "outbound": "ขาออก",
    "inboundAndOutbound": "ขาเข้าและขาออก"
  },
  "loadTypeDirections": {
    "inbound": "ขาเข้า",
    "outbound": "ขาออก",
    "inOut": "ขาเข้า & ขาออก"
  },
  "altAssetVisitTypes": {
    "unknown": "ไม่ทราบ"
  },
  "assetContainerStates": {
    "full": "เต็ม",
    "empty": "ว่าง",
    "partiallyLoaded": "บรรทุกบางส่วน"
  },
  "spotStatuses": {
    "open": "เปิด",
    "closed": "ปิด",
    "assigned": "มอบหมายแล้ว",
    "inTransit": "กำลังเคลื่อนย้าย",
    "reservedManual": "จองแล้ว",
    "reservedAutomated": "จองแล้ว",
    "unknown": "ไม่ทราบ"
  },
  "spotTypes": {
    "parking": "ที่จอด",
    "docking": "เทียบท่า"
  },
  "labels": {
    "licensePlate": "ป้ายทะเบียน",
    "dotNumber": "หมายเลข DOT"
  },
  "messages": {
    "unknownCompany": "บริษัทที่ไม่รู้จัก",
    "unhooked": "ปลดพ่วงแล้ว",
    "noInformationAvailable": "ไม่มีข้อมูล",
    "noVisitFound": "ไม่พบการเข้าพื้นที่",
    "notInformed": "ไม่ได้ระบุ",
    "waitingAssignment": "รอการมอบหมาย",
    "failedToLoadSpotDetails": "โหลดรายละเอียดช่องจอดไม่สำเร็จ",
    "retry": "ลองใหม่",
    "blockedUntilSpotIsOpen": "ถูกบล็อกจนกว่า {spot} จะเปิด",
    "blockReasons": {
      "reservedByOther": "ช่องจอดปลายทาง**ถูกจอง**ไว้สำหรับ**งานเคลื่อนย้าย #{taskNumber}**",
      "reservedByOtherGeneric": "ช่องจอดปลายทาง**ถูกจองแล้ว**",
      "destinationClosed": "ช่องจอดปลายทาง**ปิดอยู่**",
      "destinationOccupied": "ช่องจอดปลายทาง**มีอุปกรณ์อื่นอยู่แล้ว**",
      "anotherAssetInTransitForDestination": "**{assetCode}** กำลังเคลื่อนย้ายมายังช่องจอดนี้อยู่แล้ว",
      "assetInTransitElsewhere": "อุปกรณ์กำลังถูกเคลื่อนย้ายโดยงานเคลื่อนย้ายอื่นอยู่แล้ว"
    }
  }
}
